import {ObjTools} from "./objTools";

/**
 * Fabric tools.
 */
export class FabricTools {

    /**
     * Paste image in fabric canvas.
     *
     * @param event event with paste data
     * @param fabricCanvas fabric canvas
     */
    static pasteImageInFabric(event, fabricCanvas, stopPropagation, callback) {
        console.log('FabricTools.pasteImageInFabric start');

        if (ObjTools.isNully(stopPropagation)) {
            stopPropagation = true;
        }

        if (stopPropagation) {
            event.stopImmediatePropagation();
        }

        let items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let [index, item] of Object.entries(items)) {
            if (item.kind === 'file') {
                let blob = item.getAsFile();
                let reader = new FileReader();

                reader.onload = function (event) {
                    fabricCanvas.clear();

                    fabric.Image.fromURL(event.target.result, function (oImg) {
                        oImg.scaleToWidth(fabricCanvas.getWidth());
                        oImg.scaleToHeight(fabricCanvas.getHeight());

                        fabricCanvas.add(oImg);
                        fabricCanvas.renderAll();

                        console.log('FabricTools.pasteImageInFabric pasted');

                        if (!ObjTools.isNully(callback)) {
                            console.log('FabricTools.pasteImageInFabric calling callback');
                            callback();
                        }
                    }, {"left": 0, "top": 0, "scaleX": 1, "scaleY": 1});
                };
                reader.readAsDataURL(blob);
            }
        }

        console.log('FabricTools.pasteImageInFabric end');
    };

    static pasteBase64ImageInFabric(base64Image, fabricCanvas, callback) {
        console.log('FabricTools.pasteBase64ImageInFabric start');

        let blob = ObjTools.b64toBlob(base64Image, 'image/png');
        let reader = new FileReader();

        reader.onload = function (event) {
            fabricCanvas.clear();

            fabric.Image.fromURL(event.target.result, function (oImg) {
                oImg.scaleToWidth(fabricCanvas.getWidth());
                oImg.scaleToHeight(fabricCanvas.getHeight());

                fabricCanvas.add(oImg);
                fabricCanvas.renderAll();

                console.log('FabricTools.pasteBase64ImageInFabric pasted');

                if (!ObjTools.isNully(callback)) {
                    console.log('FabricTools.pasteBase64ImageInFabric calling callback');
                    callback();
                }
            }, {"left": 0, "top": 0, "scaleX": 1, "scaleY": 1});
        };
        reader.readAsDataURL(blob);

        console.log('FabricTools.pasteBase64ImageInFabric end');
    };
}